import(/* webpackMode: "eager" */ "/vercel/path0/app/(tools)/error.tsx");
